import { render, staticRenderFns } from "./license.vue?vue&type=template&id=51b75b36&scoped=true&"
import script from "./license.vue?vue&type=script&lang=js&"
export * from "./license.vue?vue&type=script&lang=js&"
import style0 from "./license.vue?vue&type=style&index=0&id=51b75b36&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b75b36",
  null
  
)

export default component.exports